/**
 * GALATEA SIGNATURE - OVERRIDE REGIONAL: PARAGUAY (es-PY)
 */

export const esPYOverride = {
  entities: {
    document: 'RUC / CI',
    state: 'Departamento',
    fiscal: 'Información SET / Marangatu',
  },
};

export default esPYOverride;
